<template>
  <v-app>
    <!-- VIEW OF THE WEBSITE -->
    <router-view />

    <!-- SNACKBAR TOAST -->
    <v-snackbar
      app
      v-model="snackbar.show"
      :color="snackbar.color"
      top
      :timeout="snackbar.timeOut"
      :outlined="snackbar.outlined"
    >
      {{ snackbar.textMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbar.closeButtonColor"
          text
          v-bind="attrs"
          @click="closeSnackBar"
        >
          <strong> {{ snackbar.buttonText }} </strong>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import customMap from "../src/views/MainDashboard/MyFarmers/components/gmap.vue";
import methods from "./helpers/methods";
import { datadogLogs } from "@datadog/browser-logs";
export default {
  name: "App",
  data() {
    return {
      isReload: true,
    };
  },
  computed: {
    snackbar() {
      return this.$store.getters["snackBar/GET_SNACKBAR"];
    },
    // setChannel(){
    //     methods.setBroadCastChannel();
    // }
  },

  mounted() {
    // MOENGAGE
    var boraodcast = new window.BroadcastChannel(
      "Krishify_brand_channel_stage"
    );
  

    console.log("env", process.env.NODE_ENV, process.env.VUE_APP_GMAP_KEY);
    if (process.env.VUE_APP_MOENGAGE_ACTIVE !== "false") {
      // let moengage = document.createElement("script");
      // const path = require("./moengage.js");
      // moengage.setAttribute("src", path);
      // moengage.setAttribute("type", "text/javascript");
      // document.body.appendChild(moengage);
    }
   

    window.addEventListener("storage", (e) => {
      // console.log("channel called", e);
      boraodcast.postMessage("message_data");

      if (e.key == "Brand-Name" && e.newValue != e.oldValue) {
        window.location.reload();
      }
    });
    console.log("env", process.env);
    if (process.env.NODE_ENV !== "development") {
      datadogLogs.init({
        clientToken: "pub97e7d22260ceb05b86335d39863052f1",
        forwardErrorsToLogs: true,
        service: "krishify-business-webapp-service",
        env: "prod",
      });
    }
  },
  components: {
    "custom-map": customMap,
  },

  methods: {
    closeSnackBar() {
      this.$store.commit("snackBar/CLOSE_SNACK_BAR");
    },
  },
};
</script>

<style scoped>
@import url("./common/css/styles.css");
</style>
